/* eslint-disable max-len */
import { observable, action, reaction } from 'mobx'
import { getFromApi } from '../services/apiService'
import { IProposedBookings, IFullVehicleModel } from './bookingTypes'
import moment from 'moment'
import { IStores } from '.'
import { sendBookingAnalyticEvent } from '../services/analyticsService'
// import { debounce } from 'lodash'

const API_DATE_FORMAT = 'YYYY-MM-DDTHH:mm'
const build_BOOKINGPROPOSITIONS_URL = (productReference:string, locationReference: string, startAt: string, endAt: string) => `/v4/reserve/bookings/${productReference}/${locationReference}/${startAt}/${endAt}`

interface ISelectionReaction {
  productReference?: string
  locationReference?: string
  startAt?: string
  endAt?: string
}

class CarsStore {
  store: IStores

  @observable loading = false;

  @observable proposedBookings: IProposedBookings | null = null;
  @observable selectedCarModel: IFullVehicleModel | null = null;

  lastReactionIdentifier = 0

  @action initialise = async ():Promise<void> => {
    this.loading = true

    this.loading = false
  };

  selectionUpdated = action(async (data: ISelectionReaction) => {
    const myReactionIdentifier = moment().valueOf()
    this.lastReactionIdentifier = myReactionIdentifier
    this.loading = true

    if (data.productReference && data.locationReference && data.startAt && data.endAt && moment(data.startAt).isBefore(data.endAt)) {
      const filters = { voucherOrPartnerCode: this.store.registerStore.partnerCode ? this.store.registerStore.partnerCode : undefined }
      const response = await getFromApi(build_BOOKINGPROPOSITIONS_URL(data.productReference, data.locationReference, data.startAt, data.endAt), filters)

      if (myReactionIdentifier !== this.lastReactionIdentifier) {
        console.debug('CarStore.reaction - cancel proposition for ', data.productReference, data.locationReference, data.startAt, data.endAt )

        return
      }
      this.proposedBookings = response && response.status === 200 ? response.data : null
      sendBookingAnalyticEvent('view_items_list', this.store.productsStore.selectedProduct, this.store.locationsStore.selectedCity, this.store.locationsStore.selectedLocation,
        this.store.calendarStore.selectedStartAt, this.store.calendarStore.selectedEndAt, this.proposedBookings?.bookings)
    }
    this.loading = false
  });

  constructor(store: IStores) {
    this.store = store

    reaction(
      () => { return { productReference: this.store.productsStore.selectedProduct?.reference, locationReference: this.store.locationsStore.selectedLocation?.reference, startAt: this.store.calendarStore.selectedStartAt?.format(API_DATE_FORMAT), endAt: this.store.calendarStore.selectedEndAt?.format(API_DATE_FORMAT) } },
      (data: ISelectionReaction) => {
        console.debug('CarStore.reaction - update proposition for ', data.locationReference, data.startAt, data.endAt )
        this.selectionUpdated(data)
      },
      { fireImmediately: false }
    )
  }
}

export default CarsStore
